var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Budget from '@hellodarwin/icons/dist/icons/Budget';
import Industry from '@hellodarwin/icons/dist/icons/Industry';
import Invoices from '@hellodarwin/icons/dist/icons/Invoices';
import Language from '@hellodarwin/icons/dist/icons/Language';
import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { dollarFormat } from '../../../features/helpers';
import useLocale from '../../../features/providers/locale-provider';
import { useTranslations } from '../../../features/providers/translations-provider';
import Button from '../../common/button';
import Div from '../../common/div';
import HdTag from '../../common/hd-tag';
import { Tablet } from '../../common/Media';
import GrantCardBox from './grant-card-box';
import { GrantCardBodyContainer, GrantCardBodyContent } from './styles';
export const SmallBodyTheme = {
    labelSize: 'overline',
    valueSize: 'body2',
    tagSize: 'small',
    iconSize: 16,
};
export const LargeBodyTheme = {
    labelSize: 'body2',
    valueSize: 'body1',
    tagSize: 'medium',
    iconSize: 20,
};
const GrantCardBody = (_a) => {
    var { locationString, cardSize } = _a, grant = __rest(_a, ["locationString", "cardSize"]);
    const theme = useTheme();
    const { t } = useTranslations();
    const { selectedLocale } = useLocale();
    const bodyTheme = useMemo(() => (cardSize === 'small' ? SmallBodyTheme : LargeBodyTheme), [cardSize]);
    const { funding_max_amount, funding_min_amount, grant_financing_type, percentage_funding, grant_industry_sectors, } = grant;
    return (_jsx(GrantCardBodyContainer, { children: _jsxs(GrantCardBodyContent, { children: [_jsx(GrantCardBox, { Icon: Budget, label: t('grant_card|eligibleFinancing'), bodyTheme: bodyTheme, children: _jsxs("ul", { children: [!!funding_min_amount && !!funding_max_amount ? (_jsx("li", { children: t('grant_card|fromMinToMax', {
                                    min: `${dollarFormat(funding_min_amount, selectedLocale)}`,
                                    max: `${dollarFormat(funding_max_amount, selectedLocale)}`,
                                }) })) : !!funding_min_amount ? (_jsx("li", { children: t('grant_card|minCount2', {
                                    minCount: `${dollarFormat(funding_min_amount, selectedLocale)}`,
                                }) })) : (!!funding_max_amount && (_jsx("li", { children: t('grant_card|maxCount2', {
                                    maxCount: `${dollarFormat(funding_max_amount, selectedLocale)}`,
                                }) }))), !!percentage_funding && (_jsx("li", { children: t('grant_card|projectCostPercent', {
                                    percent: `${percentage_funding}`,
                                }) })), !funding_min_amount &&
                                !funding_max_amount &&
                                !percentage_funding && _jsx("li", { children: t('grant_card|noCondition') })] }) }), _jsx(GrantCardBox, { Icon: Industry, label: t('grant_card|eligibleIndustries'), bodyTheme: bodyTheme, children: _jsx("ul", { style: { width: '100%' }, children: !!(grant_industry_sectors === null || grant_industry_sectors === void 0 ? void 0 : grant_industry_sectors.length) ? (React.Children.toArray(grant_industry_sectors
                            .slice(0, 4)
                            .map((tag) => _jsx("li", { children: tag }, tag)))) : (_jsx("li", { style: { width: '100%' }, children: t('grant_card|allIndustries') })) }) }), _jsx(GrantCardBox, { Icon: Invoices, label: t('grant_card|financingType'), bodyTheme: bodyTheme, children: _jsx(Div, { flex: "row", gap: 8, wrap: "wrap", children: React.Children.toArray(grant_financing_type === null || grant_financing_type === void 0 ? void 0 : grant_financing_type.map((type) => (_jsx(HdTag, { text: type, color: theme.colors.purple_3, size: bodyTheme.tagSize }, type)))) }) }), _jsxs(Tablet, { direction: "down", children: [_jsx(GrantCardBox, { Icon: Language, label: t('grant_card|region'), bodyTheme: bodyTheme, children: locationString }), _jsx(Div, { style: { padding: 24 }, children: _jsx(Button, { style: { width: '100%' }, withArrowRight: true, children: t('grant_card|learnMore') }) })] })] }) }));
};
export default GrantCardBody;
